import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../../../../components/Modal/CustomModal";
import {
    IconAvatarTable,
    IconClockTable, IconDeskOfficeTable,
    IconMarkerTable,
    IconScheduleTable,
    PeopleTalking,
    PersonOutlinedChip,
    StarCalendarTitle
} from "../../../../../components/buttons/IconButtons";
import {
    chipStatusClassColor
} from "../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import CustomCard from "../../../../../components/CustomCard";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import {EMPTY_VALUES, getDateFormat, getFullName, getTimeFormat} from "../../../../../Apis/functions";
import {invitationInTime} from "../Model/Model";
import CustomTooltip from '../../../../../components/CustomTooltip';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const IncomingInvitationDetailsModal = (props) => {
    const { onHide, itemSelected } = props;
    const { t } = useTranslation();
    const isOverdue = !invitationInTime(itemSelected?.endDate) ? STATUS_MODEL.OVERDUE : null;

    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm='confirm'
            onHide={() => {
                onHide();
            }}
            confirmButton={false}
            cancelButton={false}
            classNameBody={'pt-2'}
            topLeftHeader={
                <>
                    <div className={'d-flex align-items-center pb-3'}>
                        <div><StarCalendarTitle /></div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={`${t('invitation_by')} ${getFullName(itemSelected?.hostName, itemSelected?.hostLastName, itemSelected?.hostSecondLastName)}`}
                                classes={`font-color-general-950 fs-modal-title text-ellipsis-1-row ml-1`}
                                showIfTruncated={true}
                            />
                        </div>
                        {isOverdue && (
                            <div className={'d-flex align-items-center flex-shrink-0'}>
                                <div className='vertical-separator h-auto' />
                                <CustomUserChip
                                    className={`mt-0 ${chipStatusClassColor[isOverdue]}`}
                                    name={t(status[isOverdue]) || EMPTY_VALUES.DEFAULT}
                                    showAvatar={false}
                                    variant='large'
                                />
                            </div>
                        )}
                    </div>
                </>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <PeopleTalking className={'w-100'} />
                <div className={'row'}>
                    <div className={'col-12 my-4'}>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div className={'d-flex align-items-center'}>
                                <div><IconAvatarTable /></div>
                                <CustomTooltip
                                    text={getFullName(
                                        itemSelected?.visitorName,
                                        itemSelected?.visitorLastName,
                                        itemSelected?.visitorSecondLastName,
                                    )}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis ml-2`}
                                    showIfTruncated={true}
                                />
                            </div>
                            <div>
                                <CustomUserChip
                                    className={`mt-0 ${chipStatusClassColor[itemSelected?.visitorStatusId]}`}
                                    name={t(status[itemSelected?.visitorStatusId]) || EMPTY_VALUES.DEFAULT}
                                    showAvatar={false}
                                    variant="large"
                                    iconPosition={POSITION_MODEL.LEFT}
                                />
                                <CustomUserChip
                                    className='mt-0 chip-shades-300-00'
                                    name={"+"+ itemSelected?.visitorNumber}
                                    Icon={PersonOutlinedChip}
                                    showAvatar={true}
                                    classNameText={"ibl-font-w-600"}
                                    variant="large"
                                    iconPosition={POSITION_MODEL.LEFT}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"border-bottom-shades-300"}/>

                <div className={"row my-4"}>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        {/******* Date & Time ***********/}
                        <CustomGenericTittleIconDataChip title={t("date_and_time")}/>

                        <div className={"mt-2"}>
                            <div className={" d-flex align-items-center"}>
                                <IconScheduleTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getDateFormat(itemSelected?.startDate,false)}
                                    &nbsp;{ t("to").toLowerCase() }&nbsp;
                                    {getDateFormat(itemSelected?.endDate,false)}
                                </p>
                            </div>
                            <div className={"d-flex align-items-center"}>
                                <IconClockTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getTimeFormat(itemSelected?.startDate)}
                                    &nbsp;{ t("to").toLowerCase() }&nbsp;
                                    {getTimeFormat(itemSelected?.endDate)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        {/******* Access zone ***********/}
                        <CustomGenericTittleIconDataChip title={t("access_zone")}/>
                        <div className={"mt-2"}>
                            {itemSelected?.rootFatherZoneName &&
                            <div className={"d-flex align-items-center"}>
                                <IconMarkerTable className={"mr-8px mb-1"}/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.rootFatherZoneName}</p>
                                </div>
                            }

                            <div className={"d-flex align-items-center"}>
                                {itemSelected?.rootFatherZoneName ?  <IconDeskOfficeTable className={"mr-8px mb-1"}/> : <IconMarkerTable className={"mr-8px mb-1"}/>}
                                <p className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.zoneName}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default IncomingInvitationDetailsModal;
